import React from 'react';
import cn from 'classnames';
import { AssetInfoType, WalletKind } from 'services/requests';

import styles from './Currency.module.css';

type Props = {
  asset: AssetInfoType;
  walletKind?: WalletKind;
  isTransaction?: boolean;
};

const Currency: React.FC<Props> = ({ asset, walletKind, isTransaction = false }) => {
  const getCurrencyLabel = (walletKind?: WalletKind, isTransaction?: boolean) => {
    if (!walletKind) return '';

    if (isTransaction) {
      return walletKind === WalletKind.PRE_FUNDED ? '(Pre-funded)' : '';
    }

    return walletKind === WalletKind.PRE_FUNDED ? '(Pre-funded)' : '(Regular)';
  };

  return (
    <div className={cn(styles.wrapper)}>
      <img src={asset.imageUrl} alt={asset.code} className={cn(styles.icon)} />
      <span className={cn(styles.label)}>{`${asset.name} ${getCurrencyLabel(
        walletKind,
        isTransaction,
      )}`}</span>
    </div>
  );
};
export default Currency;
